import { Lineup, Match, Team } from 'src/mundial/requests/interfaces';
import Translator from 'src/requests/apa/Translator';

export const PREFIX = 'aaf_app_';
export const VCARD_MATCH = `${PREFIX}vcard-match`;
export const VCARD_MATCH_ALIGNMENT = `${VCARD_MATCH}-alignment`;
export const VCARD_MATCH_RESUME = `${VCARD_MATCH}-resume`;
export const VCARD_MATCH_COMMENTS = `${VCARD_MATCH}-comments`;
export const VCARD_MATCH_PLAYERS = `${VCARD_MATCH}-players`;
export const VCARD_MATCH_MENU = `${VCARD_MATCH}-menu`;
export const IN_PROGRESS = 'IN_PROGRESS';

interface IDataDispatchPlay {
    payway_token?: string;
    playerstate: string;
    source: {
        videoid: string;
        seasonid?: string;
    };
    size: {
        top: number;
        left: number;
        width: number;
        height: number;
    };
    ispreview?: boolean;
    islive: boolean;
    ispip: boolean;
    recommendations?: unknown;
    tooglePlay?: unknown;
    event?: unknown;
    languageoptions?: unknown;
    filterTV?: unknown;
    starttime?: unknown;
    deleteLastStream?: unknown;
    modalHasBeenShown?: boolean;
}

export const SOCCERPLAYER = 'soccerPlayers';
export const IDVCARDPLAYER = 'vcard-players-ribbon'

export interface ILineup extends Omit<Lineup, 'coach'> {}

export interface ITypesCurrentPeriod {
    '1H': string;
    'HT': string;
    '2H': string;
    'I90': string;
    '1ET': string;
    '2ET': string;
    'I120': string;
    'PSO': string;
    'E': string;
}

export interface IAlignmentsState {
    awayLineup: ILineup;
    homeLineup: ILineup;
}
export interface IStatesDescriptionMatch extends Match {
    phaseName: string;
    group_id: string;
    enableButton: boolean;
    interval?: NodeJS.Timeout | unknown
}

export const INIT_TEAM: Team = {
    id: '',
    name: '',
    nameAbbrev: '',
    flag: '',
    logo: '',
};

export const INIT_MATCH: IStatesDescriptionMatch = {
    id: 'string',
    homeTeam: INIT_TEAM,
    awayTeam: INIT_TEAM,
    date: new Date(),
    status: '',
    stadium: '',
    phaseName: '',
    group_id: '',
    enableButton: false,
};

export const INIT_LINEUP: ILineup = {
    formation: '',
    players: [],
};

export const INIT_ALIGNMENTS: IAlignmentsState = {
    awayLineup: INIT_LINEUP,
    homeLineup: INIT_LINEUP,
};

export const KEYS_SUMMARY = [
    'ballPossession',
    'cardsRed',
    'cardsYellow',
    'offsides',
    'fouls',
    'shotsTotal',
    'shotsOnGoal',
    'freeKicks',
    'corners',
    'scoringOpportunities',
    'shotsBlocked',
    'penaltyKicks',
];

export const ROWS = [
    { text: Translator.get('match_resume_ballPossession_label', 'Posesión') },
    { text: Translator.get('match_resume_cardsRed_label', 'Tarjetas rojas') },
    { text: Translator.get('match_resume_cardsYellow_label', 'Tarjetas amarillas') },
    { text: Translator.get('match_resume_offsides_label', 'Fueras de juego') },
    { text: Translator.get('match_resume_fouls_label', 'Faltas') },
    { text: Translator.get('match_resume_shotsTotal_label', 'Tiros totales') },
    { text: Translator.get('match_resume_shotsOnGoal_label', 'Tiros a gol') },
    { text: Translator.get('match_resume_freeKicks_label', 'Tiros libres') },
    { text: Translator.get('match_resume_corners_label', 'Tiros de esquina') },
    { text: Translator.get('match_resume_hitsPost_label', 'Tiros al arco') },
    { text: Translator.get('match_resume_shotsBlocked_label', 'Tiros bloqueados') },
    { text: Translator.get('match_resume_penaltyKicks_label', 'Penaltis') },
];

export const subMenu = [
    {
        name: Translator.get('match_access_option_button_alignment', 'ALINEACIÓN'),
        href: '/alignments',
    },
    { name: Translator.get('match_comments_resume_label', 'RESUMEN'), href: '/resume' },
    {
        name: Translator.get('match_access_option_button_comments', 'COMENTARIOS'),
        href: '/comments',
    },
    { name: Translator.get('match_access_option_button_players', 'JUGADORES'), href: '/players' },
];

//* Se deja de utilizar por la función getStatusPlay que arma la llave
export const TYPE_CURRENT_PERIOD: ITypesCurrentPeriod = {
    '1H': Translator.get('match_detail_info_games_label_one_time', '1er tiempo'),
    'HT': Translator.get('match_detail_info_games_label_half_time', 'Medio tiempo'),
    '2H': Translator.get('match_detail_info_games_label_two_time', '2do tiempo'),
    'I90': Translator.get('match_detail_info_games_label_break_time', 'Descanso de tiempo reglamentario'),
    '1ET': Translator.get('match_detail_info_games_label_one_time_extra', '1er tiempo extra'),
    '2ET': Translator.get('match_detail_info_games_label_two_time_extra', '2do tiempo extra'),
    'I120': Translator.get('match_detail_info_games_label_penalties_extra', 'Penales'),
    'PSO': Translator.get('match_detail_info_games_label_penalties', 'Penales'),
    'E': Translator.get('match_detail_info_games_label_COMPLETED', 'Finalizado'),
};

export const VERSUS = Translator.get('matches_result_separatorVersus_label', 'VS');
// export const VERSUS_LOWER = Translator.get('match_detail_separatorVersus_label', 'vs.');
export const WATCH_NOW = Translator.get('match_detail_players_label', 'Ver ahora');
export const SEPARATOR = Translator.get('matches_result_separatorPipe_label', '|');
export const HOURS = Translator.get('match_detail_hourAbbreviation_label', 'hs');
export const STADIUM = Translator.get('match_access_stadium_label', 'Estadio:');

export const TITLE_COMMENTS = Translator.get('match_comments_title_label', 'COMENTARIOS DEL PARTIDO');
export const NO_COMMENTS = Translator.get('match_comments_empty_label', 'Este partido aún no comienza, cuando comience podrás seguir los comentarios aquí.');

export const BLUE_BUTTON_COMMENTS = Translator.get('match_comments_goFirstMinute_label', 'IR AL PRIMER MINUTO');
export const GREEN_BUTTON_COMMENTS = Translator.get('match_comments_goLastMinute_label', 'IR AL ÚLTIMO MINUTO');

export const HOME = 'local';
export const AWAY = 'visit';

//Mundial
export const VCARDPARTIDO = 'vcard-partido';




// WEBPACK FOOTER //
// ./src/mundial/Vcards/VcardMatch/utils/constants.ts